module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3tEt2"))).then(() => parcelRequire('d0iPb'));